import { Box, Typography, alpha, useTheme } from '@mui/material';
import { Message } from '../../../type/chat.types';

const MessageReplyPreview = ({ message }: { message: Message }) => {
    const theme = useTheme();
    const reply = message.reply_to;

    if (!reply) return null;

    const author = reply.user?.isAdmin
        ? 'کارشناس پشتیبانی'
        : [reply.user?.name, reply.user?.family].filter(Boolean).join(' ') || 'کاربر';

    return (
        <Box
            sx={{
                mb: 1,
                px: 1.1,
                py: 0.75,
                borderRadius: 1.5,
                borderRight: '3px solid',
                borderRightColor: 'primary.main',
                bgcolor: alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.1 : 0.06),
                minWidth: 0,
            }}>
            <Typography
                variant="caption"
                sx={{ display: 'block', color: 'primary.main', fontWeight: 600, mb: 0.2 }}>
                {author}
            </Typography>
            <Typography
                variant="caption"
                sx={{
                    display: 'block',
                    color: 'text.secondary',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}>
                {reply.text}
            </Typography>
        </Box>
    );
};

export default MessageReplyPreview;
